import React from "react";
import { formatDuration } from "../utils/formatDuration";

export default function UserSummaryCards({
  sessionCount,
  eventCount,
  avgSessionMs,
  showAvgSession = true,
  eventLabel = "API Requests",
}) {
  const cards = [
    {
      label: "Sessions",
      value: sessionCount === undefined || sessionCount === null ? "—" : sessionCount,
    },
    {
      label: eventLabel,
      value:
        eventCount === undefined || eventCount === null ? "—" : eventCount,
    },
  ];

  if (showAvgSession) {
    cards.push({ label: "Avg Session", value: formatDuration(avgSessionMs) });
  }

  return (
    <div className="summary-cards">
      {cards.map(({ label, value }) => (
        <div key={label} className="summary-card">
          <div className="summary-card__label">{label}</div>
          <div className="summary-card__value">{value}</div>
        </div>
      ))}
    </div>
  );
}
